import { render, staticRenderFns } from "./RecentData.vue?vue&type=template&id=5c86cbc2&scoped=true&"
import script from "./RecentData.vue?vue&type=script&lang=js&"
export * from "./RecentData.vue?vue&type=script&lang=js&"
import style0 from "./RecentData.vue?vue&type=style&index=0&id=5c86cbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86cbc2",
  null
  
)

export default component.exports